import { Component, OnInit, OnDestroy } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { UserService } from 'src/app/core/services/user.service';
import { LoggingService } from 'src/app/core/services/logging.service';
import { Helper } from 'src/app/core/helper';

@Component({
    selector: "app-auth",
    templateUrl: "./auth.component.html",
    styleUrls: ["./auth.component.scss"],
    standalone: false
})
export class AuthComponent implements OnInit, OnDestroy {
  constructor(private userService: UserService, private route: ActivatedRoute, private router: Router) {
    LoggingService.log("AuthComp ctor");
  }

  private redirectUrl: string;
  private paramsSub$: Subscription;

  ngOnInit() {
    LoggingService.log("AuthComp init");
    this.paramsSub$ = this.route.queryParams.subscribe(params => {
      this.redirectUrl = params.r;
    });

    this.userService.login$().subscribe(
      success => {
        if (success) {
          let redirectUrl = this.redirectUrl;

          if (!redirectUrl) {
            redirectUrl = "/";
          }

          LoggingService.log(`AuthComp redirecting to ${redirectUrl}`);

          this.router.navigateByUrl(redirectUrl);
        } else {
          Helper.navigateExternal("https://bemerri.com");
        }
      },
      err => {
        LoggingService.log("login error " + JSON.stringify(err));
      },
      () => {
        LoggingService.log("login complete");
      }
    );
  }

  ngOnDestroy() {
    if (this.paramsSub$) this.paramsSub$.unsubscribe();
  }
}
